// extracted by mini-css-extract-plugin
export default {"container":"plans_container__wVjQJ","planContainer":"plans_planContainer__C-NYR","icon":"plans_icon__0e6RU"};